import React from "react";
import UserMenuModule from "./userMenuModule";
import {Provider} from "react-redux";
import {createReduxStore} from "./redux/store";
import PropTypes from "prop-types";

export let userMenuStore;

export function createStore() {
  userMenuStore = createReduxStore("userMenu");
  return userMenuStore;
}

class UserMenu extends React.Component {
  render() {
    return (
      <Provider store={createStore()}>
        <UserMenuModule userParams={this.props} currentUser={this.props.currentUser}/>
      </Provider>
    );
  }
}

UserMenu.propTypes = {
  currentUser: PropTypes.object
};

export default UserMenu;
